var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productDetail-container" },
    [
      _c("div", { staticStyle: { background: "#f5f5f5" } }, [
        _c("div", [
          _c("div", { staticClass: "shop" }, [
            _c("div", { staticClass: "shopHeaderBj" }, [
              _c(
                "div",
                {
                  staticClass: "warp",
                  staticStyle: {
                    padding: "20px",
                    position: "relative",
                    background: "#fff",
                    "border-radius": "18px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "shopInfo-box",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "shop1",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-start",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("div", { staticClass: "shopLogo" }, [
                            _vm.shopLogo
                              ? _c("img", {
                                  attrs: { src: _vm.shopLogo, alt: "" }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../../../assets/images/logo.png"),
                                    alt: ""
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "shopHeard" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "left"
                                }
                              },
                              [
                                _c("div", [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "shopName",
                                      on: {
                                        click: function($event) {
                                          return _vm.goStore()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.curShop.shopName) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "guanzhu",
                                    style:
                                      _vm.isCare == 0
                                        ? ""
                                        : "background-color: rgba(255, 71, 71, 1);color: #fff;",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.collectShop.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.isCare == 0 ? "关注" : "已关注"
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "information" }, [
                              _c("span", { staticClass: "dizhi" }, [
                                _c("i", {
                                  staticClass: "icon-positioning",
                                  staticStyle: {
                                    color: "#fb7600",
                                    "font-size": "20px",
                                    "margin-right": "5px"
                                  }
                                }),
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(this.adressForm.shopAdress) +
                                    "\n                    "
                                )
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end",
                            "align-items": "center"
                          }
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "shopBtn",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.toStore(_vm.collectData.shopId)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/images/b2c/dianpu.png"),
                                  alt: "",
                                  srcset: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("进入店铺")])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "productBox warp" }, [
        _c(
          "div",
          { staticClass: "productConcise clearfix" },
          [
            _c(
              "div",
              { staticClass: "swiper-box" },
              [
                _c(
                  "swiper",
                  {
                    ref: "swiperTop",
                    staticClass: "gallery-top",
                    staticStyle: { border: "1px solid #e4e4e4" },
                    attrs: { options: _vm.swiperOptionTop }
                  },
                  _vm._l(_vm.productDetailData.images, function(item) {
                    return _c(
                      "swiper-slide",
                      { key: item, staticStyle: { "text-align": "center" } },
                      [
                        _c("img", {
                          staticStyle: { height: "100%", width: "auto" },
                          attrs: { src: item, alt: "" }
                        })
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "swiperThumbsLeft" }, [
                  _c(
                    "div",
                    { staticClass: "thumbsBox" },
                    [
                      _c(
                        "swiper",
                        {
                          ref: "swiperThumbs",
                          staticClass: "gallery-thumbs",
                          attrs: { options: _vm.swiperOptionThumbs }
                        },
                        _vm._l(_vm.productDetailData.images, function(
                          item,
                          index
                        ) {
                          return _c(
                            "swiper-slide",
                            { key: index, attrs: { img: item } },
                            [
                              _c("img", {
                                attrs: { src: item, alt: "", srcset: "" }
                              })
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "image-button-prev",
                          attrs: { slot: "button-prev" },
                          slot: "button-prev"
                        },
                        [_c("a-icon", { attrs: { type: "left" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "image-button-next",
                          attrs: { slot: "button-next" },
                          slot: "button-next"
                        },
                        [_c("a-icon", { attrs: { type: "right" } })],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "left",
                      width: "440px",
                      "padding-left": "10px",
                      "margin-bottom": "-30px",
                      "margin-top": "50px"
                    }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "favoritesBtn",
                        attrs: { title: "收藏" },
                        on: { click: _vm.collect }
                      },
                      [
                        _c("span", {
                          class:
                            "" +
                            (_vm.productDetailData.ifCollect === 0
                              ? "icon-shoucang"
                              : "icon-shoucang1")
                        }),
                        _vm._v(" "),
                        _vm.productDetailData.ifCollect === 0
                          ? _c(
                              "span",
                              { staticStyle: { color: "#000000a6" } },
                              [_vm._v("收藏")]
                            )
                          : _c(
                              "span",
                              { staticStyle: { color: "#000000a6" } },
                              [_vm._v("已收藏")]
                            )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("a-spin", { attrs: { spinning: _vm.spinning } }, [
              _c("div", { staticClass: "proDuctInfo" }, [
                _c("h3", { staticClass: "productTit" }, [
                  _vm._v(_vm._s(_vm.productDetailData.productName))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "introduction" }, [
                  _vm._v(_vm._s(_vm.productDetailData.productBrief))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "priceDataInfo" }, [
                  _vm.currentProductData.activityType === 1 && false
                    ? _c("div", [
                        _c("div", { staticClass: "groupBuyInfo" }, [
                          _c("div", { staticClass: "groupLeft" }, [
                            _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("拼团专区")])
                          ]),
                          _vm._v(" "),
                          _vm.ifEnable === 0
                            ? _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.productDetailData.person) +
                                    "人团\n                "
                                )
                              ])
                            : _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productOption.skuTool.startTime
                                    ) +
                                    " 活动开启\n                "
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "priceSpike mar-bot-20" }, [
                          _c("div", { staticClass: "priceSpikeLeft" }, [
                            _vm._v(
                              "\n                  拼团价：\n                  "
                            ),
                            _c("b", [
                              _vm._v(
                                "￥" + _vm._s(_vm.currentProductData.price)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm.currentProductData.originalPrice)
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.activityType === 2 && false
                    ? _c("div", [
                        _c("div", { staticClass: "groupBuyInfo" }, [
                          _c("div", { staticClass: "groupLeft" }, [
                            _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("秒杀专区")])
                          ]),
                          _vm._v(" "),
                          _vm.ifEnable === 0
                            ? _c("div", { staticClass: "countdown" }, [
                                _c("div", { staticClass: "countdownTit" }, [
                                  _vm._v("距离结束:")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "timeDown" }, [
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("formatHours")(_vm.endTime))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMinutes")(_vm.endTime)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatSeconds")(_vm.endTime)
                                      )
                                    )
                                  ])
                                ])
                              ])
                            : _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productOption.skuTool.startTime
                                    ) +
                                    " 活动开启\n                "
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "priceSpike mar-bot-20" }, [
                          _c("div", { staticClass: "priceSpikeLeft" }, [
                            _vm._v(
                              "\n                  秒杀价：\n                  "
                            ),
                            _c("b", [
                              _vm._v(
                                "￥" + _vm._s(_vm.currentProductData.price)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm.currentProductData.originalPrice)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.productDetailData.total && _vm.ifEnable === 0
                            ? _c(
                                "div",
                                { staticClass: "priceSpikeRight" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                    限量" +
                                        _vm._s(_vm.productDetailData.total) +
                                        "件/还剩" +
                                        _vm._s(
                                          _vm.productDetailData.surplusNumber
                                        ) +
                                        "件\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-progress", {
                                    attrs: {
                                      "text-inside": true,
                                      "stroke-width": 10,
                                      percentage:
                                        ((_vm.productDetailData.total -
                                          _vm.productDetailData.surplusNumber) /
                                          _vm.productDetailData.total) *
                                        100,
                                      status: "exception"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.activityType === 3 && false
                    ? _c("div", [
                        _c("div", { staticClass: "groupBuyInfo" }, [
                          _c("div", { staticClass: "groupLeft" }, [
                            _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("限时折扣")])
                          ]),
                          _vm._v(" "),
                          _vm.ifEnable === 0
                            ? _c("div", { staticClass: "countdown" }, [
                                _c("div", { staticClass: "countdownTit" }, [
                                  _vm._v("距离结束:")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "timeDown" }, [
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("formatHours")(_vm.endTime))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMinutes")(_vm.endTime)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatSeconds")(_vm.endTime)
                                      )
                                    )
                                  ])
                                ])
                              ])
                            : _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productOption.skuTool.startTime
                                    ) +
                                    " 活动开启\n                "
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "priceSpike mar-bot-20" }, [
                          _c("div", { staticClass: "priceSpikeLeft" }, [
                            _vm._v(
                              "\n                  折扣价：\n                  "
                            ),
                            _c("b", [
                              _vm._v(
                                "￥" + _vm._s(_vm.currentProductData.price)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm.currentProductData.originalPrice)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.productDetailData.total && _vm.ifEnable === 0
                            ? _c(
                                "div",
                                { staticClass: "priceSpikeRight" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                    限量" +
                                        _vm._s(_vm.productDetailData.total) +
                                        "件/还剩" +
                                        _vm._s(
                                          _vm.productDetailData.surplusNumber
                                        ) +
                                        "件\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-progress", {
                                    attrs: {
                                      "text-inside": true,
                                      "stroke-width": 10,
                                      percentage:
                                        ((_vm.productDetailData.total -
                                          _vm.productDetailData.surplusNumber) /
                                          _vm.productDetailData.total) *
                                        100,
                                      status: "exception"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "promotionInfo" }, [
                    _c("span", [_vm._v("价格")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        _c("span", [
                          _c("small", [_vm._v("¥")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "-2px" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.currentProductPrice.min) +
                                  "\n                  "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.currentProductPrice.min !==
                        _vm.currentProductPrice.max
                          ? [
                              _c("span", [_vm._v("-")]),
                              _vm._v(" "),
                              _c("span", [
                                _c("small", [_vm._v("¥")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "-2px" } },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.currentProductPrice.max) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "proDiscount" },
                    [
                      _vm._l(_vm.productDetailData.markTools, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "activityLabel" },
                          [
                            _c("span", [_vm._v(_vm._s(item.activityName))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("优惠券：" + _vm._s(item.content))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.getThisCoupon(item, index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      item.state === 3 ? "领取" : "已领取"
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.productDetailData.shopMarkTools, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "activityLabel" },
                          [
                            _c("span", [_vm._v(_vm._s(item.activityName))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("优惠券：" + _vm._s(item.content))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.getThisCoupon1(item, index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      item.state === 3 ? "领取" : "已领取"
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sku-box" }, [
                  _c("ul", [
                    _c("li", { staticClass: "proDescribeTit-parent" }, [
                      _c("p", { staticClass: "proDescribeTit" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.productOption.names[0].skuName === ""
                                ? ""
                                : _vm.productOption.names[0].skuName + ""
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        _vm._l(_vm.productOption.names[0].values, function(
                          kt,
                          index
                        ) {
                          return _c(
                            "span",
                            {
                              key: index,
                              class: [{ "selected-item": kt.selected }],
                              on: {
                                click: function($event) {
                                  return _vm.selectSku(
                                    kt,
                                    _vm.productOption.names[0]
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(kt.skuValue))]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-container" }, [
                    _c("span", [_vm._v("规格")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          "" +
                          (_vm.tableData.length > 6 && _vm.isHidden
                            ? "table-hiddenbox"
                            : "")
                      },
                      [
                        _c("a-table", {
                          class:
                            "" +
                            (_vm.tableData.length > 6 && _vm.isHidden
                              ? "table-hidden"
                              : ""),
                          attrs: {
                            columns: _vm.columns,
                            "data-source": _vm.tableData,
                            scroll: _vm.columns.length > 7 ? { x: 500 } : {},
                            pagination: false,
                            size: "small"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "buyNum",
                              fn: function(item) {
                                return _c(
                                  "div",
                                  {},
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        min: 0,
                                        step: 1,
                                        value:
                                          _vm.buyNumMap["" + item.skuId] || 0,
                                        label: "购买数量",
                                        size: "small",
                                        type: "number"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.buyNumChange($event, item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _vm.tableData.length > 6
                            ? _c(
                                "div",
                                {
                                  staticClass: "table-hidden-btn",
                                  on: {
                                    click: function($event) {
                                      _vm.isHidden = !_vm.isHidden
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    class:
                                      "" +
                                      (_vm.isHidden
                                        ? "el-icon-arrow-down"
                                        : "el-icon-arrow-up")
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "total-info" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.totalInfo.totalNum) + " 件")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.totalInfo.totalPrice) + " 元")
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("已选清单")])
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "initBuyNumBox" }, [
                  _c("span", [_vm._v("销量")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.productDetailData.number))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btnBox" }, [
                  _vm.currentProductData.activityType === 0 &&
                  (_vm.currentProductData.stockNumber !== 0 ||
                    _vm.productDetailData.ifOversold == 1) &&
                  _vm.productDetailData.shelveState
                    ? _c("div", { staticClass: "buyBox" }, [
                        _c(
                          "div",
                          {
                            staticClass: "buyBox2",
                            attrs: { disabled: _vm.ableToBuy },
                            on: { click: _vm.buyGood }
                          },
                          [_vm._v("\n                立即购买\n              ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "addCartBox",
                            attrs: { disabled: _vm.ableToBuy },
                            on: { click: _vm.clickAddCart }
                          },
                          [
                            _vm._v(
                              "\n                加入购物车\n              "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.currentProductData.activityType === 2 &&
                    (_vm.currentProductData.stockNumber !== 0 ||
                      _vm.productDetailData.ifOversold == 1) &&
                    _vm.productDetailData.shelveState) ||
                  (_vm.currentProductData.activityType === 3 &&
                    (_vm.currentProductData.stockNumber !== 0 ||
                      _vm.productDetailData.ifOversold == 1) &&
                    _vm.productDetailData.shelveState)
                    ? _c("div", { staticClass: "buyBox" }, [
                        _c(
                          "div",
                          {
                            staticClass: "buyBox2",
                            attrs: { disabled: _vm.ableToBuy },
                            on: { click: _vm.buyGood }
                          },
                          [_vm._v("\n                立即购买\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.ifEnable === 1
                          ? _c(
                              "div",
                              {
                                staticClass: "addCartBox",
                                attrs: { disabled: _vm.ableToBuy },
                                on: { click: _vm.clickAddCart }
                              },
                              [
                                _vm._v(
                                  "\n                加入购物车\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.activityType === 1 &&
                  (_vm.currentProductData.stockNumber !== 0 ||
                    _vm.productDetailData.ifOversold == 1) &&
                  _vm.productDetailData.shelveState
                    ? _c("div", { staticClass: "favorites" }, [
                        _c(
                          "div",
                          {
                            staticClass: "buyBox2",
                            attrs: { disabled: _vm.ableToBuy },
                            on: { click: _vm.buyGood }
                          },
                          [_vm._v("\n                立即购买\n              ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "addCartBox",
                            attrs: { disabled: _vm.ableToBuy },
                            on: { click: _vm.clickAddCart }
                          },
                          [
                            _vm._v(
                              "\n                加入购物车\n              "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.stockNumber === 0 &&
                  _vm.productDetailData.shelveState &&
                  _vm.productDetailData.ifOversold == 0
                    ? _c("div", { staticClass: "noStock" }, [
                        _c("span", [_vm._v("已售空")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.productDetailData.shelveState
                    ? _c("div", { staticClass: "noStock" }, [
                        _c("span", [_vm._v("已下架")])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "initBuyNumBox initBuyNumBox_bottom" },
                  [
                    _c("span", [_vm._v("付款方式")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm.enablePaymentMode.indexOf(3) != -1 || _vm.shopType
                        ? _c("p", [
                            _c("span", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/images/offline_pay.png"),
                                  alt: "",
                                  srcset: ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("转账汇款")])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.enablePaymentMode.indexOf(4) != -1
                        ? _c("p", [
                            _c("span", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/images/online_credit_pay.png"),
                                  alt: "",
                                  srcset: ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("账期付款")])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.enablePaymentMode.indexOf(6) != -1
                        ? _c("p", [
                            _c("span", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/images/jufutong.png"),
                                  alt: "",
                                  srcset: ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("聚富通支付")])
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _vm.currentProductData.activityType === 1 &&
            _vm.productDetailData.collageOrders.length &&
            _vm.ifEnable === 0
              ? _c("div", { staticClass: "pinList" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pinListBox" },
                    _vm._l(_vm.productDetailData.collageOrders, function(item) {
                      return _c(
                        "div",
                        { key: item.collageId, staticClass: "pinItem" },
                        [
                          _c("div", { staticClass: "Avatar" }, [
                            _c("img", {
                              attrs: { src: item.headImage, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pinUserInfo" }, [
                            _c("span", { staticClass: "pUserName" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "notBad" }, [
                              _vm._v(
                                "\n                还差\n                "
                              ),
                              _c("b", [_vm._v(_vm._s(item.person))]),
                              _vm._v("人拼成\n              ")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "remainingTime" }, [
                              _vm._v(
                                "\n                剩余：\n                "
                              ),
                              _c("b", [
                                _vm._v(_vm._s(_vm._f("formatTime")(item.time)))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          !item.lock
                            ? _c(
                                "div",
                                {
                                  staticClass: "pinBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.goToGroupBuy(item.collageId)
                                    }
                                  }
                                },
                                [_vm._v("\n              和Ta拼\n            ")]
                              )
                            : _c("div", { staticClass: "pinBtn" }, [
                                _vm._v("已结束")
                              ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.tuijianItem.length > 0
          ? _c("div", { staticClass: "tuijianModel" }, [
              _c("div", { staticClass: "tuijian" }, [
                _c(
                  "div",
                  { staticClass: "beijing" },
                  [
                    _vm.noProduct
                      ? _c(
                          "swiper",
                          {
                            staticClass: "swiper lunbo",
                            attrs: { options: _vm.swiperOption }
                          },
                          [
                            _vm._l(_vm.tuijianItem, function(item) {
                              return _c(
                                "swiper-slide",
                                { key: item, staticClass: "swiper-slide cel" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "swiper-content",
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "6px"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "142px",
                                          height: "142px"
                                        },
                                        attrs: {
                                          src: item.image,
                                          alt: "",
                                          srcset: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toProductDetail(item)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "swiper-pagination",
                              attrs: { slot: "pagination" },
                              slot: "pagination"
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "swiper-button-prev",
                                attrs: { slot: "button-prev" },
                                slot: "button-prev"
                              },
                              [_c("i", { staticClass: "el-icon-arrow-left" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "swiper-button-next",
                                attrs: { slot: "button-next" },
                                slot: "button-next"
                              },
                              [_c("i", { staticClass: "el-icon-arrow-right" })]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "warp" }, [
          _c(
            "div",
            {
              staticClass: "bottom",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c("div", { staticClass: "shopBufen" }, [
                _c("div", { staticClass: "xinxi" }, [
                  _vm.curShop.shopLogo
                    ? _c("div", { staticClass: "topModel" }, [
                        _c("div", { staticClass: "shopMingzi" }, [
                          _c("span", { staticClass: "wenben" }, [
                            _vm._v(_vm._s(_vm.curShop.shopName))
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: {
                              height: "20px",
                              "margin-top": "-8px",
                              "margin-left": "5px"
                            },
                            attrs: {
                              src: require("../../../assets/images/wangwang.png"),
                              alt: ""
                            }
                          })
                        ])
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "topModel",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _c("div", { staticClass: "shopMingzi" }, [
                            _c("span", { staticClass: "wenben" }, [
                              _vm._v(_vm._s(_vm.curShop.shopName))
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: {
                                height: "20px",
                                "margin-top": "-8px",
                                "margin-left": "5px"
                              },
                              attrs: {
                                src: require("../../../assets/images/wangwang.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.adressForm.shopAdress
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "left",
                            padding: "10px 0 10px 20px"
                          }
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "e",
                              staticStyle: {
                                height: "19px",
                                "line-height": "19px",
                                "margin-left": "10px"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    "font-family": "MicrosoftYaHei",
                                    color: "#333333",
                                    "line-height": "19px"
                                  }
                                },
                                [_vm._v(_vm._s(this.adressForm.shopAdress))]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tiaozhuan" }, [
                    _c(
                      "div",
                      {
                        staticClass: "jindainguang",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toStore(_vm.collectData.shopId)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon-add11" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              "font-family": "MicrosoftYaHei",
                              color: "#333333",
                              "line-height": "50px"
                            }
                          },
                          [_vm._v("进店逛逛")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "shoucang",
                        staticStyle: { cursor: "pointer" },
                        attrs: { title: "收藏" },
                        on: { click: _vm.collectShop }
                      },
                      [
                        _c("span", {
                          class:
                            "" +
                            (_vm.isCare === 0
                              ? "icon-shoucang"
                              : "icon-shoucang1")
                        }),
                        _vm._v(" "),
                        _vm.isCare === 0
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family": "MicrosoftYaHei",
                                  color: "#333333",
                                  "line-height": "19px"
                                }
                              },
                              [_vm._v("收藏店铺")]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family": "MicrosoftYaHei",
                                  color: "#333333",
                                  "line-height": "19px"
                                }
                              },
                              [_vm._v("已收藏店铺")]
                            )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "classfiy" },
                  [
                    _c("div", { staticClass: "innerclassify" }),
                    _vm._v(" "),
                    _c("el-card", { staticClass: "box-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [_c("span", [_vm._v("店内分类")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "317px", height: "540px" } },
                        [
                          _c("el-tree", {
                            attrs: {
                              data: _vm.categoryItem,
                              props: _vm.defaultProps
                            },
                            on: { "node-click": _vm.goStoreClassify }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "productDetail" },
                [
                  _c(
                    "a-tabs",
                    { attrs: { type: "card" } },
                    [
                      _c(
                        "a-tab-pane",
                        { key: "1", attrs: { tab: "商品详情" } },
                        [
                          _c("div", { staticClass: "detailBox" }, [
                            _c("div", {
                              staticClass: "detailCont",
                              domProps: {
                                innerHTML: _vm._s(_vm.productDetailData.text)
                              }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        { key: "2", attrs: { tab: "商品评价" } },
                        [
                          _vm.pinjiaList.length > 0
                            ? _c(
                                "div",
                                { staticClass: "pinjiaBox" },
                                _vm._l(_vm.pinjiaList, function(item, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "item" },
                                    [
                                      _c("div", { staticClass: "infoBox" }, [
                                        _c("div", { staticClass: "leftInfo" }, [
                                          _c("img", {
                                            attrs: {
                                              src: item.headImage,
                                              alt: "",
                                              srcset: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "info" }, [
                                            _c("div", { staticClass: "name" }, [
                                              _vm._v(_vm._s(item.name))
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "time" }, [
                                              _vm._v(_vm._s(item.createTime))
                                            ])
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "rightInfo" },
                                          [
                                            _c("el-rate", {
                                              attrs: { disabled: "" },
                                              model: {
                                                value: item.star,
                                                callback: function($$v) {
                                                  _vm.$set(item, "star", $$v)
                                                },
                                                expression: "item.star"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "comment" }, [
                                        _vm._v(_vm._s(item.comment))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "addImages" },
                                        _vm._l(item.addImages, function(
                                          img,
                                          index2
                                        ) {
                                          return _c("img", {
                                            key: index2,
                                            attrs: {
                                              src: item,
                                              alt: "",
                                              srcset: ""
                                            }
                                          })
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("div", { staticClass: "noorder" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../../static/image/noorder@2x.png"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "fs20 font-color-999" },
                                  [_vm._v("暂无商品评价～")]
                                )
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        { key: "3", attrs: { tab: "商品问答" } },
                        [
                          _vm.problemList.length > 0
                            ? _c(
                                "div",
                                { staticClass: "pinjiaBox" },
                                _vm._l(_vm.problemList, function(item, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "item" },
                                    [
                                      _c("div", { staticClass: "infoBox" }, [
                                        _c("div", { staticClass: "leftInfo" }, [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              item.headImage
                                                ? _c("img", {
                                                    attrs: {
                                                      src: item.headImage,
                                                      alt: "",
                                                      srcset: ""
                                                    }
                                                  })
                                                : _c("img", {
                                                    attrs: {
                                                      src:
                                                        "https://static.xhngyl.com/xhngyl-platform-gy/avatar/2021-08-24/4588b24faf4c4588a0878eeef5fcd4b3-avatar.png",
                                                      alt: "",
                                                      srcset: ""
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    position: "absolute",
                                                    bottom: "0",
                                                    right: "10px",
                                                    "border-radius": "2px",
                                                    padding: "0px 2px",
                                                    "background-color":
                                                      "#FF8700",
                                                    color: "#fff",
                                                    "font-size": "12px"
                                                  }
                                                },
                                                [_vm._v("问")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "info" }, [
                                            _c("div", { staticClass: "name" }, [
                                              _vm._v(_vm._s(item.name))
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "time" }, [
                                              _vm._v(_vm._s(item.createTime))
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "comment" }, [
                                        _vm._v(_vm._s(item.problem))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "addImages",
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "flex-start",
                                            "margin-left": "60px",
                                            "align-items": "flex-start"
                                          }
                                        },
                                        _vm._l(item.answers, function(
                                          item2,
                                          index2
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index2,
                                              staticClass: "item",
                                              staticStyle: { width: "100%" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "infoBox" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "leftInfo" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            position: "relative"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "40px"
                                                            },
                                                            attrs: {
                                                              src:
                                                                item2.headImage,
                                                              alt: "",
                                                              srcset: ""
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                position:
                                                                  "absolute",
                                                                bottom: "0",
                                                                right: "10px",
                                                                "border-radius":
                                                                  "2px",
                                                                padding:
                                                                  "0px 2px",
                                                                "background-color":
                                                                  "#FF4B29",
                                                                color: "#fff",
                                                                "font-size":
                                                                  "12px"
                                                              }
                                                            },
                                                            [_vm._v("答")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "info" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item2.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "time"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item2.createTime
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "comment" },
                                                [_vm._v(_vm._s(item2.answer))]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("div", { staticClass: "noorder" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../../static/image/noorder@2x.png"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "fs20 font-color-999" },
                                  [_vm._v("暂无商品问答～")]
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.groupBuyDialog,
            width: "30%",
            "before-close": _vm.groupBuyClose
          },
          on: {
            "update:visible": function($event) {
              _vm.groupBuyDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("是否跟他拼团？")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.groupBuyClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.openGroup(0)
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "shopBtn" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/b2c/kefu.png"),
          alt: "",
          srcset: ""
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("联系客服")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "server" }, [
      _c("span", [
        _c("img", {
          attrs: {
            src: require("../../../assets/images/wangwang.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("联系客服")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fightOrderTit" }, [
      _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
      _vm._v(" "),
      _c("span", [_vm._v("这些人正在拼单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d" }, [
      _c("span", { staticClass: "icon-positioning" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-26d2b0cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-26d2b0cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/b2c/product/productDetail.vue
// module id = null
// module chunks = 